import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { NewClientsApiService } from 'features/new-clients/api/new-clients-api.service';
import { queryClient } from 'providers';

import { NewClientsQueryKeys } from './query-keys';

const { createClients, updateClients } = NewClientsApiService();

export const useCreateClients = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return createClients(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: NewClientsQueryKeys.all,
        });
      },
    },
  );
};

export const useUpdateClients = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return updateClients(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
    },
  );
};
